import { createGenericTypes, createGenericActions } from "utils/createAction";

export const searchTypes = createGenericTypes("SEARCH");
export const searchActions = createGenericActions(searchTypes);
